
import React from "react";

const InfoContent = () => {
  return (
    <section className="space-y-10 text-gray-800 text-base leading-loose text-justify">
      <div className="space-y-0 border-b pb-4">
        <p>
          <strong>Abone Halı Yıkama</strong> olarak, halı, koltuk ve stor/zebra temizleme hizmetlerinde 
          <strong> kaliteli, güvenli ve hijyenik</strong> çözümler sunuyoruz. 
          Halılarınız özel <strong>antibakteriyel şampuanlarla</strong> ve 
          <strong> profesyonel makinelerde</strong> temizlenir. Ürünlerinize zarar vermeyen 
          özel bakım yöntemleriyle hijyenik bir şekilde teslim edilir.
        </p>
      </div>

      <div className="space-y-2 border-b pb-4">
        <h3 className="font-semibold text-lg text-[#00704A]">Abone Halı Yıkama – Hijyenin Yeni Hali.</h3>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Deneyimli ekip</strong> ve modern makinelerle derinlemesine temizlik.</li>
          <li><strong>Organik ürünlerle</strong> çevre dostu temizlik.</li>
          <li>Stor, zebra, yorgan, battaniye ve perde gibi ev tekstil ürünleri özenle yıkanır.</li>
          <li><strong>Ücretsiz servis</strong> ile adresten alım ve teslimat.</li>
          <li>Ürünleriniz <strong>steril ambalajla</strong> teslim edilir.</li>
        </ul>
      </div>

      <div className="space-y-2 border-b pb-4">
        <h3 className="font-semibold text-lg text-[#00704A]">Neden Abone Halı Yıkama?</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>Kapıdan alım ve teslimat ile <strong>ücretsiz servis</strong>.</li>
          <li><strong>Hijyenik ortamda</strong> profesyonel temizlik.</li>
          <li>Antibakteriyel ürün ve ekipman kullanımı.</li>
          <li><strong>Uzman personel</strong> ve gelişmiş yıkama sistemleri.</li>
        </ul>
      </div>

      <div className="space-y-2 border-b pb-4">
        <h3 className="font-semibold text-lg text-[#00704A]">Biz Kimiz ve Size Nasıl Yardımcı Oluyoruz?</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>Profesyonel temizlikte <strong>çözüm ortağınız</strong>.</li>
          <li>Halı dışında <strong>koltuk, yorgan, zebra ve stor perde</strong> yıkama hizmeti sunuyoruz.</li>
          <li>Yaşam alanlarınıza <strong>hijyen, ferahlık ve konfor</strong> getiriyoruz.</li>
        </ul>
      </div>

      <div className="space-y-2 border-b pb-4">
        <h3 className="font-semibold text-lg text-[#00704A]">Neden Bizi Tercih Etmelisiniz?</h3>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Gelişmiş sistemler</strong> ile etkili ve hızlı temizlik.</li>
          <li><strong>%100 müşteri memnuniyeti</strong> garantisi.</li>
          <li>Uygun fiyat politikası ve kampanyalı hizmetler.</li>
          <li><strong>Zamanında teslimat</strong> ve kaliteli işçilik.</li>
        </ul>
      </div>

      <div className="space-y-2">
        <h3 className="font-semibold text-lg text-[#00704A]">Ek Avantajlar:</h3>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Ücretsiz servis</strong> hizmeti tüm Ankara geneline sunulur.</li>
          <li><strong>Yerinde koltuk ve perde yıkama</strong> imkânı.</li>
          <li><strong>Güler yüzlü hizmet</strong> ve güvenilir ekip.</li>
        </ul>
      </div>
    </section>
  );
};

export default InfoContent;
